// assets/js/utilities/utilitiesAll.js
import { initHamburgerMenu } from './hamburgerMenu';
import { initUpdateHeaderHeight } from './headerProcessing';
import { initHeaderVisibility } from './headerVisibility';
import { initZoomModal } from './zoomModal';
import { initExternalLinkModal } from './externalLinkModal';
import { initBorderGrayMaxWidth } from './borderGrayMaxWidth';
import { initTelLinkControl } from './telLinkControl';
import TableScrollGuide from './tableScrollGuide';
import { initTabs } from './tabs';
import { initSideNavToggle } from './sideNavToggle';
import { initSideNavCurrent } from './sideNavCurrent';
import { initHeaderNavCurrent } from './headerNavCurrent';
import { initImageCarousel } from './imageCarousel';
import { initBenaviSwiper } from './benaviSwiper';
import { initInfoSwiper } from './infoSwiper';
import { initMovieModal } from './movieModal';
import { initImageSwitcher } from './imageSwitcher';
import { initPopupToggle } from './popupToggle';
import { initDisclaimerModal } from './disclaimerModal';
import { initCopyrightYear } from './copyrightYear';
import { initJstreamPlayer } from './jstreamPlayer';
import { initScheduleFilter } from './scheduleFilter';
import { initMediiBanner } from './mediiBanner';
import { initHideProductBanners } from './hideProductBanners';

export default async function utilitiesAll() {
  try {
    await Promise.all([
      initHamburgerMenu(),
      initUpdateHeaderHeight(),
      initHeaderVisibility(),
      initZoomModal(),
      initExternalLinkModal(),
      initBorderGrayMaxWidth(),
      initTelLinkControl(),
      initTabs(),
      initSideNavToggle(),
      initSideNavCurrent(),
      initHeaderNavCurrent(),
      initImageCarousel(),
      initBenaviSwiper(),
      initInfoSwiper(),
      initMovieModal(),
      initImageSwitcher(),
      initPopupToggle(),
      initDisclaimerModal(),
      initCopyrightYear(),
      initJstreamPlayer(),
      initScheduleFilter(),
      initMediiBanner(),
      initHideProductBanners(),
    ]);

    // Initialize table scroll guide
    new TableScrollGuide();
  } catch (error) {
    console.error("Error in utilitiesAll:", error);
  }
}
